<div [hidden]="!loading">
  <div class="loading-spinner loading-container">
    <div class="loading-wrapper">
      <img class="align-self-end mx-auto"
          [src]="commonService?.getOrgWindowObject?.LOGO_URL ? commonService?.getOrgWindowObject?.LOGO_URL : 'assets/images/logo.png'"
          onerror="this.src='assets/images/logo.png';" alt="...">
      <div class="wrap-container inside-loader my-2">
        <div class="spinner main">
          <div class="rect1"></div>
          <div class="rect2"></div>
          <div class="rect3"></div>
          <div class="rect4"></div>
          <div class="rect5"></div>
        </div>
      </div>
      <span class="text-center font-size-21 font-weight-bold">{{loadingMessage}}</span>
      <div class="color--gray font-size-12 mt-10 text-center">
        Report Preview Preparation might take up to 60 seconds to complete.
      </div>
    </div>
  </div>
</div>
